export default function minsToRead(length, multiplier = 1) {
    return Math.round((length / 150) * multiplier)
}